import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import TopNavigation from './TopNavigation';
// import Sidebar from './Sidebar';
import { navigation } from '../config/navigation';

const Layout = () => {
  const { user } = useAuth();
  const location = useLocation();
  const [currentPageTitle, setCurrentPageTitle] = useState('Dashboard');

  useEffect(() => {
    const currentPage = navigation.find(item => 
      location.pathname === item.href || location.pathname.startsWith(item.href + '/'));
    if (currentPage) {
      setCurrentPageTitle(currentPage.name);
    }
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-gray-50">
      <TopNavigation />
      
      <div className="flex justify-center">
        {/* <Sidebar /> */}
        
        {/* Main content */}
        <main className="w-full max-w-7xl px-4 sm:px-6 lg:px-8 py-8"> 
          <div className="fade-in">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout; 